export {default} from './QueueingTimeView'
